/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit-w': {
    width: 16,
    height: 16,
    viewBox: '0 0 10.65 10.65',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M9.08 5.33v4.16a.84.84 0 0 1-.84.84H1.16a.84.84 0 0 1-.84-.84V2.41a.84.84 0 0 1 .84-.84h4.17"/><path pid="1" class="cls-1" d="M5.67 6.94l-.52.52a.62.62 0 0 1-.32.17L2.87 8l-.25-.25.39-2a.63.63 0 0 1 .17-.32L8 .73a1.39 1.39 0 0 1 2 2L7 5.57"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/edit-w.js